module.exports = __webpack_public_path__ + "images/shimo/board-new-2cf5803f4f0c8d3f6e5625edf7ea72a9.png";